import { PublicClientApplication, LogLevel, EventType } from '@azure/msal-browser';

const TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID || 'e5a14ac6-18b2-405d-8925-6a510fb500a3';
const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID || 'c5bee968-59d8-4e14-94e7-21ae24356ec6';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: `${window.location.origin}/login`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.MODE === 'production' ? LogLevel.Error : LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Listen for login success events — this fires regardless of who calls handleRedirectPromise
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.idToken) {
    window.__msalRedirectResult = event.payload;
  }
  if (event.eventType === EventType.LOGIN_FAILURE) {
    window.__msalRedirectError = event.error;
  }
});
